var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#14C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1075 6.45645C14.4636 6.74502 14.688 7.34183 14.6093 7.78002L13.8443 12.0123C13.7644 12.4533 13.3425 12.9387 12.9083 13.0911L8.73506 14.5565C8.30081 14.7089 7.65506 14.5986 7.29956 14.3101L3.89194 11.5443C3.53588 11.2557 3.31088 10.6617 3.39131 10.2207L4.15631 5.98845C4.23563 5.54745 4.6575 5.06258 5.09231 4.90958L9.26606 3.4437C9.70088 3.2907 10.3461 3.40208 10.7021 3.69008L14.1075 6.45645ZM10.5576 8.35658L10.7274 7.49595L9.13444 7.49877L9.35944 6.36477H8.84475C8.47349 6.93372 7.93274 7.37155 7.299 7.61633L7.15444 8.35827H7.85081C7.85081 8.35827 7.61513 9.42364 7.53581 9.81683C7.33894 10.8181 7.83394 11.528 8.59444 11.528H9.88144L10.1064 10.5773H9.02981C8.55169 10.5773 8.577 10.3158 8.66981 9.8517L8.96625 8.35433L10.5576 8.35658Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.7563cb6fd062e1f7ae036c04eb10f951.svg";
export { ForwardRef as ReactComponent };